import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { listarDesvios  } from '../../services/apigateway';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import ProcessandoModal from '../../components/Processamento/processamento';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';

import Axios from 'axios';

export default function Desvios(){
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [desvios, setDesvios] = useState([]);
  const [desvioFiltrado, setDesvioFiltrado] = useState([]);
  const [desvioPaginado, setDesvioPaginado] = useState([]);

  const [loading, setLoading] = useState(true);

  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    {coluna: 'cod_desvio', cabecalho: 'Código', alinhamento: 'tdtabela'},
    {coluna: 'des_desvio', cabecalho: 'Descrição', alinhamento: 'tdtabelaleft'},
    {coluna: 'sit_desvio', cabecalho: 'Situação', alinhamento: 'tdtabela'}, 
    {coluna: 'ação', cabecalho: 'Ação', alinhamento: 'tdtabela'}
  ];

  useEffect(() => {
      loadDesvios();
      return() => {}
  }, []);

  async function loadDesvios(){
    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }

      const result = await listarDesvios(clienteId);
      setDesvios(result);

      let dados = filterDesvios(result, '');
      setDesvioFiltrado(dados);
   
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarDesvios(dados, 0, qtdLinhas);
      setDesvioPaginado(datas);
      setLoading(false);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);
    }

    setLoading(false);
  }

  function filterDesvios(dados, texto) {
    let data = [];
    // console.log("dados em desvios.js: ", dados);
    
    dados && dados.filter(item => {return item.des_desvio.toLowerCase().includes(texto)}).map(dado => {
      data.push(dado)
    });

    return data; 
  }  
 
  function paginarDesvios(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(texto) {
    let dados = filterDesvios(desvios, texto);
    setDesvioFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarDesvios(dados, 0, qtdLinhas)
    setDesvioPaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarDesvios(desvioFiltrado, posicao, qtdLinhas);
    setDesvioPaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = desvioFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(desvioFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarDesvios(desvioFiltrado, 0, valor);
    setDesvioPaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...desvioFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setDesvioFiltrado(dataCopy); 

    let data = paginarDesvios(dataCopy, 0, qtdLinhas);
    setDesvioPaginado(data); 
    setCurrentPage(0); 
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Desvios'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando Desvios..." />
        </section>
      </main>
    </div>
    )
  }

  
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo 
          tela={'Cadastro de Desvios'} 
          destination='/desvios/inclusao/'
          permissao='DESVIO_INCLUIR'
        />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <div>  
            <div className="flex flex items-center gap-4 p-2">
              <label>Desvio:</label>
              <div className="single-input">
                <input 
                  type="text" 
                  id='descricao' 
                  name='descricao' 
                  placeholder='Descrição do Desvio' 
                  className='p-2 border border-gray-300 rounded-md' 
                  autoComplete='descricao' 
                  onChange={e => handleSearch(e.target.value)}
                />
              </div>
            </div>
            <Tabela
              entidade='Desvios' 
              dados={desvioPaginado}
              elementos={elementos}
              handleSort={handleSort}
              sortedId={coluna}
              ordem={ordem}
              urlBase='/desvios'
            />

            {qtdPaginas > 1 ? (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {desvioFiltrado.length} 
                />
                
                <Paginate
                  qtdPaginas={qtdPaginas}
                  handlePageClick={handlePageClick}
                  currentPage={currentPage}
                />

              </div>
            ) : (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {desvioFiltrado.length} 
                />
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
    );
  }
  